import React, { useContext, useEffect, useState } from 'react';
import styles from './PrivateKeyStorageModal.module.css';
import useTheme from "config/useTheme";
import Loader from 'components/shared/loader/Loader';
import { useFetchPermissions } from 'api/permissions/usePermissions';
import ModalContext from 'config/context/modalContext';
import { useSetAuthKey } from 'api/authentication/usePrivateKey';
import AuthenticationContext from 'config/context/authenticationContext';
import ModalShell from 'components/shared/modal/ModalShell';
import SuccessfullActionModal from './SuccessfullActionModal';
import SelectModalOption from './SelectModalOption';
import PrivateKeyField from 'components/shared/private-key-field/PrivateKeyField';

const PrivateKeyStorageModal = () => {
    const { dark } = useTheme();
    const { handleModal } = useContext(ModalContext);
    const { isPermissionValid, permissionsList } = useContext(AuthenticationContext);
    const [selectedPermission, setSelectedPermission] = useState('');
    const [privateKey, setPrivateKey] = useState('');
    const [msg, setMsg] = useState(<p style={{ color: '#37a0f6' }}>Enter new auth private key</p>);

    const { loading: fetchPermissionsLoading, error: fetchPermissionsError } = useFetchPermissions();
    const { response: setAuthKeyResponse, loading: setAuthKeyLoading, error: setAuthKeyError, setAuthKey } = useSetAuthKey({
        permissionName: selectedPermission,
        privateKey: privateKey
    });

    const handleInputChange = (e) => {
        e.preventDefault();
        setPrivateKey(e.target.value);
    }

    // Message handling only
    useEffect(() => {
        if (setAuthKeyError) {
            setMsg(<p style={{ color: '#db0000' }}>{setAuthKeyError}</p>);
        } else if (setAuthKeyResponse) {
            setMsg(<p style={{ color: '#37a0f6' }}>{setAuthKeyResponse?.message}</p>);
            if (setAuthKeyResponse?.status) {
                setTimeout(() => {
                    handleModal(false);
                }, 1600);
            }
        } else {
            if (isPermissionValid(selectedPermission)) {
                setMsg(<p style={{ color: '#37a0f6' }}>Edit auth private key for "{selectedPermission}"</p>);
            } else {
                setMsg(<p style={{ color: '#37a0f6' }}>Enter new auth private key</p>);
            }
        }
    }, [setAuthKeyError, setAuthKeyResponse, selectedPermission, handleModal, isPermissionValid]);

    const handleSubmit = (event) => {
        event.preventDefault();
        setAuthKey();
    }

    if (fetchPermissionsLoading || setAuthKeyLoading) return <ModalShell><Loader /></ModalShell>;
    if (setAuthKeyResponse?.status) return (
        <ModalShell><SuccessfullActionModal message={setAuthKeyResponse?.message} /></ModalShell>
    );

    return (
        <ModalShell closeOnOverlay={true}>
            <div className={`${styles.component} ${dark ? styles.dark : ""}`}>
                <div className={styles.label}>Set Auth Private Key</div>
                {fetchPermissionsError ? <p>Error during data fetch!</p> : <>
                    <SelectModalOption
                        placeholder={selectedPermission ? selectedPermission : 'Select permission'}
                        setOption={setSelectedPermission}
                        optionList={permissionsList}
                    />
                    <form id='private_key_storage_form' onSubmit={handleSubmit}>
                        {msg}
                        <PrivateKeyField
                            placeholder="Private key"
                            value={privateKey}
                            onChange={handleInputChange}
                        />
                    </form>
                </>}
                <div className={styles.form_actions}>
                    <button
                        type='submit'
                        form='private_key_storage_form'
                        disabled={!(selectedPermission && privateKey) || fetchPermissionsError}
                    >
                        Submit key
                    </button>
                    <button onClick={() => handleModal(false)}>Cancel</button>
                </div>
            </div>
        </ModalShell>
    )
}

export default PrivateKeyStorageModal;